import React from "react";
import PropTypes from "prop-types";
import { PageHeaderBarContainer, PageHeaderBarStaticContent, PageHeaderBarButtons } from "./partial";

const PageHeaderBar = ({ buttons, title, ...props }) => {
  return (
    <PageHeaderBarContainer>
      <PageHeaderBarStaticContent buttons={buttons} title={title} {...props} />
      <PageHeaderBarButtons buttons={buttons} onlyIcon={!title} />
    </PageHeaderBarContainer>
  );
};

PageHeaderBar.propTypes = {
  /**
   * Clase adicional del componente.
   */
  className: PropTypes.string,
  /**
   * Elemento con el contenido de la botonera
   */
  buttons: PropTypes.element,
  /**
   * Título de la cabecera
   */
  title: PropTypes.string,
};

export default PageHeaderBar;
